document.addEventListener("DOMContentLoaded", function () {
  // Configuration object
  const CONFIG = {
    SELECTORS: {
      PRICE: [".price-item--regular", ".price-item--sale"],
      VARIANT: [".varientWrapper input"],
      FORM: {
        PRODUCT_FORM: ".product-form",
        SELLING_PLAN_INPUT: 'input[name="selling_plan"]',
        RADIO_SELECTOR_QUANTITY_INPUT: "input[name='customQuantitySelector']",
        QUANTITY_INPUT: "input.quantity__input",
        SUBMIT_BUTTON: ".product-form__submit",
        STICKY_PRICE: ".sticky-price",
        STICKY_COMPARED_PRICE: ".sticky-price-compared-price",
      },
      RECHARGE: {
        WIDGET: ".rc-widget.rc_widget",
        ONETIME_OPTION: ".rc-option__onetime",
        RADIO_INPUT: ".rc-radio__input",
        SELLING_PLANS: ".rc-selling-plans.rc_widget__option__plans",
        SUBSCRIPTION_OPTION: ".rc-option__subsave",
        DISCOUNT_ELEMENT: ".rc-option__discount",
        ONETIME_PRICE: ".regularPrice",
      },
    },
    RETRY_DELAY: 500,
    PRICE_UPDATE_DELAY: 1500,
  };

  class ReChargeWidgetManager {
    constructor() {
      this.initialized = false;
    }

    async initialize() {
      try {
        await this.waitForReChargeWidget();
        this.addWidget();
        this.initialized = true;
      } catch (error) {
        console.error("Failed to initialize ReCharge widget:", error);
      }
    }

    async waitForReChargeWidget() {
      return new Promise((resolve, reject) => {
        const check = () => {
          if (typeof window.ReChargeWidget?.createWidget === "function") {
            resolve();
          } else {
            setTimeout(check, CONFIG.RETRY_DELAY);
          }
        };
        check();
      });
    }

    addWidget() {
      const productId = parseInt(product_id);
      if (!productId) {
        throw new Error("Invalid product ID");
      }

      const widgetConfig = {
        productId,
        injectionParent: "#injectrechargehere",
        injectionMethod: "append",
        selectors: CONFIG.SELECTORS,
      };

      window.ReChargeWidget.createWidget(widgetConfig);
      this.setupAdditionalFeatures();
    }

    setupAdditionalFeatures() {
      setTimeout(() => {
        this.addSubscriptionBenefits();
        this.setupSellingPlanToggle();
        this.updateDiscountText();
      }, CONFIG.PRICE_UPDATE_DELAY);
    }

    addSubscriptionBenefits() {
      const plansContainer = document.querySelector(
        CONFIG.SELECTORS.RECHARGE.SELLING_PLANS
      );
      if (!plansContainer) return;
      document.querySelector(".rc-option__text").innerHTML =
        "Subscribe and Save <span>+ Get Free Shipping</span>";
      const benefits = [
        `<b>Best Value: </b> Save ${sellPercentage}% every order`,
        "<b>Free Shipping: </b>Fast & free delivery, always",
        "<b>Convenient: </b>Never run out of your favorites",
        "<b>Flexible: </b>Edit, pause, cancel anytime",
      ];
      const ul = document.createElement("ul");
      benefits.forEach((benefit) => {
        const li = document.createElement("li");
        li.innerHTML = benefit;
        ul.appendChild(li);
      });

      const parentElements = document.querySelectorAll(
        ".rc_widget__option__label"
      );
      const referenceNodes = document.querySelectorAll(
        ".rc_widget__price--subsave"
      );
      const referenceNodesoneTime = document.querySelectorAll(
        ".rc_widget__price--onetime"
      );

      parentElements.forEach((parentElement, index) => {
        const referenceNode = referenceNodes[index];
        const referenceNodeoneTime = referenceNodesoneTime[index];
        if (referenceNodeoneTime) {
          // Create a new span element for the regular price
          const regularPriceEleNew = document.createElement("span");
          regularPriceEleNew.classList.add("regularPrice", "addednewPrice");

          // Get the text content from the reference node
          const regularprice = referenceNodeoneTime.textContent;

          // Set the innerHTML of the new element to the regular price
          regularPriceEleNew.innerHTML = regularprice;

          // Append the new element after the reference node
          referenceNodeoneTime.insertAdjacentElement(
            "afterend",
            regularPriceEleNew
          );
        }
        if (referenceNode) {
          // Create a new element for each insertion

          const comparedPricedivAt = document.createElement("span");
          const subRegPrice = document.createElement("span");

          const subregPriceElement = document.querySelector(
            ".rc_widget__price--subsave"
          );
          const subregPriceActual = document.querySelector(
            ".rc_widget__price--subsave"
          ).textContent;
          subRegPrice.classList.add("subregularPrice", "addednewPrice");
          subRegPrice.innerHTML = `${subregPriceActual}`;

          comparedPricedivAt.classList.add("discountedPrice"); // Add any class as needed
          comparedPricedivAt.innerHTML = `<strike>$${parseFloat(
            product_price
          ).toFixed(2)}</strike>`; // Assuming `product_price` is defined

          // Insert the element after the reference node
          referenceNode.insertAdjacentElement("afterend", comparedPricedivAt);
          referenceNode.insertAdjacentElement("afterend", subRegPrice);
        }
      });

      $(CONFIG.SELECTORS.RECHARGE.SELLING_PLANS).parent().append(ul);
    }

    setupSellingPlanToggle() {
      const updateSellingPlanClass = () => {
        const widget = document.querySelector(CONFIG.SELECTORS.RECHARGE.WIDGET);
        const onetimeInput = document.querySelector(
          `${CONFIG.SELECTORS.RECHARGE.ONETIME_OPTION} ${CONFIG.SELECTORS.RECHARGE.RADIO_INPUT}`
        );

        if (!widget || !onetimeInput) return;

        widget.classList.toggle("selling-plan-active", onetimeInput.checked);
      };

      document
        .querySelectorAll(CONFIG.SELECTORS.RECHARGE.RADIO_INPUT)
        .forEach((input) =>
          input.addEventListener("change", updateSellingPlanClass)
        );

      updateSellingPlanClass();
    }

    updateDiscountText() {
      const discountElement = document.querySelector(
        CONFIG.SELECTORS.RECHARGE.DISCOUNT_ELEMENT
      );
      const qtyElement = document?.querySelector(
        CONFIG.SELECTORS.FORM.QUANTITY_INPUT
      );
      if (discountElement) {
        const discountValue = discountElement.textContent.trim();
        const qtyElementVal = qtyElement.value;
        const stickPriceData = document
          .querySelector("#sticky-price-data")
          ?.getAttribute("data-bundled_discount_price");
        const savePriceWithQty =
          parseFloat(stickPriceData) * parseFloat(qtyElementVal);
        discountElement.textContent = `Save $${Math.ceil(
          parseFloat(savePriceWithQty)
        )}`;
      }
    }
  }

  class PriceManagerOld {
    constructor() {
      this.setupPriceUpdateListeners();
      this.setupQuantityChangeListener();
      this.ReChargeWidgetManager = new ReChargeWidgetManager();
    }

    setupQuantityChangeListener() {
      document
        .querySelector(CONFIG.SELECTORS.FORM.PRODUCT_FORM)
        ?.querySelector(CONFIG.SELECTORS.FORM.QUANTITY_INPUT)
        ?.addEventListener("change", (event) => {
          event.preventDefault();
          this.handlePriceUpdate(event);
        });
    }

    setupPriceUpdateListeners() {
      document.body.addEventListener(
        "change",
        this.handlePriceUpdate.bind(this)
      );
      this.setupQuantityPriceUpdates();
    }

    setupQuantityPriceUpdates() {
      const radioButtons = document.querySelectorAll(".radioChecSingle input");
      radioButtons.forEach((radio) => {
        radio.addEventListener("click", () => {
          this.handleQuantityPriceUpdate(radio);
          this.ReChargeWidgetManager.updateDiscountText();
        });
      });
    }

    handleQuantityPriceUpdate(radio) {
      if (
        !document.querySelector(
          `${CONFIG.SELECTORS.RECHARGE.SUBSCRIPTION_OPTION} input`
        )?.checked
      ) {
        return;
      }

      setTimeout(() => {
        const price = this.calculateUpdatedPrice(radio);
        this.updatePriceDisplay(price);
      }, 0);
    }

    calculateUpdatedPrice(radio) {
      const isSingleUnit = radio.checked;
      const basePrice = parseFloat(
        radio
          .getAttribute(isSingleUnit ? "data-price" : "data-orginalPrice")
          .replace(/[^0-9.-]+/g, "")
      );
      const quantity = parseInt(radio.value);
      const discountPercent =
        selling_groups_plan[0].selling_plans[0].price_adjustments[0].value;

      if (isSingleUnit) {
        return (basePrice - (basePrice * discountPercent) / 100) * quantity;
      }

      const singleDiscount = parseFloat(
        radio.getAttribute("data-discountedPrice").replace(/[^0-9.-]+/g, "")
      );
      console.log(singleDiscount);
      return (
        basePrice * quantity * (1 - discountPercent / 100) -
        singleDiscount * quantity
      );
    }

    updatePriceDisplay(price) {
      const priceElements = document.querySelectorAll(
        CONFIG.SELECTORS.FORM.STICKY_PRICE
      );
      priceElements.forEach((element) => {
        element.textContent = `$${price.toFixed(2)}`;
      });
    }

    handlePriceUpdate(event) {
      event.preventDefault();
      if (
        !event.target.classList.contains("rc-radio__input") &&
        !event.target.classList.contains("quantity__input") &&
        !event.target.name.includes("customQuantitySelector")
      )
        return;
      console.log("aasd", event.target);

      this.showFrequency();

      const formElements = this.getProductFormElements();
      const { sellingPlanInput, productQtyInput } = formElements;

      if (!sellingPlanInput || !productQtyInput) {
        console.warn("Required form elements not found");
        return;
      }

      const selectedValue = sellingPlanInput.value;
      var quantity = parseFloat(productQtyInput.value) || 1;
      if (event.target.name.includes("customQuantitySelector")) {
        quantity = parseFloat(event.target.value) || 1;
      }

      if (selectedValue) {
        const discountedPrice = this.findSellingPlanPercentage(
          selectedValue,
          quantity,
          formElements
        );
        this.updateFormPrice(
          discountedPrice,
          compared_price,
          quantity,
          formElements
        );
      } else {
        this.updateFormPrice(
          product_price,
          compared_price,
          quantity,
          formElements
        );
      }
    }

    showFrequency() {
      var frequency_displayer = document.querySelector(".frequency_title span");
      var purchaseOptionRadios = document.querySelectorAll(
        ".rc_widget__option__input"
      );
      var savePercentage = document.querySelector(
        ".rc_widget__option__discount"
      ).textContent;

      if (purchaseOptionRadios.length > 0) {
        purchaseOptionRadios.forEach((radio) => {
          if (radio.checked) {
            if (radio.value == "onetime") {
              frequency_displayer.innerHTML = "One time purchase";
            } else {
              frequency_displayer.innerHTML = `Subscribe & Save ${sellPercentage}%`;
            }
          }
        });
      }
    }

    findSellingPlanPercentage(selectedValue, productQty, formElements) {
      if (!selling_groups_plan || !Array.isArray(selling_groups_plan)) {
        console.error("Selling plans data is not available or invalid.");
        return;
      }

      for (let planObj of selling_groups_plan) {
        const matchingSellingPlan = planObj?.selling_plans?.find(
          (plan) => plan.id == selectedValue
        );

        if (matchingSellingPlan) {
          const discountValue =
            matchingSellingPlan?.price_adjustments?.[0]?.value;

          if (discountValue != null && !isNaN(discountValue)) {
            const discountAmount = (product_price * discountValue) / 100;
            const discountedPrice = product_price - discountAmount;

            // this.updateFormPrice(
            //   discountedPrice,
            //   compared_price,
            //   productQty,
            //   formElements
            // );
            return discountedPrice;
          }
        }
      }
    }

    updateFormPrice(price, comparedPrice, qty, formElements) {
      const { stickyPrice, stickyComparedPrice } = formElements;
      this.updatePriceDisplay(price * qty);
      if (stickyPrice) {
        stickyPrice.textContent = `$${(price * qty).toFixed(2)}`;
      }

      if (stickyComparedPrice) {
        stickyComparedPrice.textContent = `$${(comparedPrice * qty).toFixed(
          2
        )}`;
      }
    }

    getProductFormElements() {
      const form = document.querySelector(CONFIG.SELECTORS.FORM.PRODUCT_FORM);
      const submitBtn = form?.querySelector(
        CONFIG.SELECTORS.FORM.SUBMIT_BUTTON
      );

      return {
        productForm: form,
        sellingPlanInput: form?.querySelector(
          CONFIG.SELECTORS.FORM.SELLING_PLAN_INPUT
        ),
        productQtyInput: form?.querySelector(
          CONFIG.SELECTORS.FORM.QUANTITY_INPUT
        ),
        stickyPrice: submitBtn?.querySelector(
          CONFIG.SELECTORS.FORM.STICKY_PRICE
        ),
        stickyComparedPrice: submitBtn?.querySelector(
          CONFIG.SELECTORS.FORM.STICKY_COMPARED_PRICE
        ),
      };
    }
  }

  // PriceManager object encapsulates data and methods for handling price updates
  const PriceManager = {
    // Initialize properties for product data, selectors, and event listeners
    productId: product_id,
    sellingGroupsPlan: selling_groups_plan,
    sellPercentage: sellPercentage,
    productPrice: product_price, // Initial price without discount
    comparedPrice: compared_price, // Initial compared price without discount
    selectors: {
      quantitySelector: "input[name='customQuantitySelector']",
      subscriptionSelector: ".rc-radio__input",
      addToCart: ".sticky-price",
      comparedPrice: ".sticky-price-compared-price",
    },

    // Method to initialize event listeners
    init() {
      this.bindEvents();
      this.waitForElement(".rc_container_wrapper", 1500, () => {
        this.globalTriggerFunction("", true);
      });
    },

    // Set up event listeners for quantity and subscription selection
    bindEvents() {
      document.body.addEventListener("change", (e) =>
        this.updatePrices.call(this, e)
      );
    },

    // Method to handle all price updates based on selected options
    updatePrices(event) {
      if (!event || !event.target) {
        console.error("Event object is missing or target is undefined");
        return;
      }

      if (
        !event.target.classList.contains("rc-radio__input") &&
        !event.target.classList.contains("quantity__input") &&
        !event.target.name.includes("customQuantitySelector")
      )
        return;
      this.globalTriggerFunction(event, false);
    },

    waitForElement(selector, timeout, callback) {
      const intervalTime = 100; // Interval in ms for checking the element
      let elapsedTime = 0;

      const interval = setInterval(() => {
        const element = document.querySelector(selector);

        // If element is found, trigger the callback and clear the interval
        if (element) {
          clearInterval(interval);
          callback();
        }

        // Increment elapsed time and check if timeout is reached
        elapsedTime += intervalTime;
        if (elapsedTime >= timeout) {
          clearInterval(interval); // Stop searching after timeout
          console.warn(
            `Element with selector "${selector}" not found within ${timeout} ms.`
          );
        }
      }, intervalTime);
    },

    globalTriggerFunction(event, pageLoaded) {
      const quantity = this.getSelectedQuantity();
      const subscription = this.getSelectedSubscription();
      if (!quantity || !subscription) return; // Exit if selections are incomplete

      const sellingPlanId = document.querySelector(
        'input[name="selling_plan"]'
      )?.value; // Example selling plan ID or empty for one-time purchase
      const result = this.calculateDiscount(
        this.sellingGroupsPlan,
        sellingPlanId,
        this.sellPercentage,
        this.productPrice,
        this.comparedPrice,
        quantity.value,
        quantity.discountType,
        quantity.discountPrice
      );
      console.log("result", result);

      // Update DOM elements for price and compared price based on calculations
      this.updateCommonChanges(result);
      this.updateDOMPrices(result, quantity.showPriceIn);
      if (
        event?.target?.classList.contains("rc-radio__input") ||
        pageLoaded == true
      ) {
        this.updateQuantityBoxPrices(result);
      }
      if (
        event?.target?.name.includes("customQuantitySelector") ||
        pageLoaded == true
      ) {
        this.updateSubscriptionBoxPrices(quantity);
      }
    },

    // Retrieve selected quantity option and its attributes
    getSelectedQuantity() {
      const selectedQuantity = document.querySelector(
        `${this.selectors.quantitySelector}:checked`
      );
      if (!selectedQuantity) return null;

      return {
        value: parseInt(selectedQuantity.value),
        showPriceIn: selectedQuantity.dataset.showPriceIn,
        discountType: selectedQuantity.dataset.subscriptionDiscountType,
        discountPrice: parseFloat(selectedQuantity.dataset.discountPrice),
      };
    },

    // Retrieve selected subscription type (one-time or subscribe)
    getSelectedSubscription() {
      const selectedSubscription = document.querySelector(
        `${this.selectors.subscriptionSelector}:checked`
      );
      if (!selectedSubscription) return null;

      return {
        type: selectedSubscription.value,
        label: selectedSubscription.dataset.labelDiscount || "",
      };
    },

    showFrequency(type, savedPercentage) {
      var frequency_displayer = document.querySelector(".frequency_title span");
      if (type == "onetime") {
        frequency_displayer.innerHTML = "One time purchase";
      } else {
        // frequency_displayer.innerHTML = `Subscribe & Save ${parseFloat(
        //   savedPercentage
        // ).toFixed(0)}%`;
        frequency_displayer.innerHTML = `Subscribe & Save ${parseFloat(
          sellPercentage
        ).toFixed(0)}%`;
      }
    },

    showQuantitySelected(totalQty) {
      var quantity_displayer = document.querySelector(".quantity_title span");
      quantity_displayer.innerHTML = ` ${parseFloat(totalQty).toFixed(
        0
      )} Shower Kit`;
    },

    //Js calculations

    getSellingPlanDiscount(sellingGroups, sellingPlanId, defaultPercentage) {
      if (sellingPlanId) {
        const selectedPlan = sellingGroups.find((plan) =>
          plan.selling_plans.some((sp) => sp.id == sellingPlanId)
        );
        if (selectedPlan) {
          return selectedPlan.selling_plans[0].price_adjustments[0].value;
        }
      }
      return defaultPercentage; // Fallback to default if no selling plan ID or match
    },

    calculateSubscriptionDiscount(
      productPrice,
      comparedPrice,
      quantity,
      discountType,
      discountPrice,
      effectiveDiscountPercentage
    ) {
      let discountAmount, finalAmount, savedPercentage, savedPrice;

      if (discountType === "one_time") {
        discountAmount = productPrice * (effectiveDiscountPercentage / 100);
        finalAmount = productPrice - discountAmount;
      } else {
        discountAmount =
          productPrice * (effectiveDiscountPercentage / 100) + discountPrice;
        finalAmount = productPrice - discountAmount;
      }

      const difference = comparedPrice - finalAmount;
      savedPercentage = (difference / comparedPrice) * 100;
      savedPrice = comparedPrice - finalAmount;

      return {
        discountAmount: discountAmount.toFixed(2),
        savedPercentage: savedPercentage.toFixed(2),
        finalAmount: finalAmount.toFixed(2),
        savedPrice: savedPrice.toFixed(2),
      };
    },

    calculateOneTimeDiscount(
      productPrice,
      comparedPrice,
      discountType,
      discountPrice
    ) {
      let discountAmount, finalAmount, savedPercentage, savedPrice;

      if (discountType === "percentage") {
        discountAmount = 0;
        finalAmount = productPrice - discountAmount;
        savedPercentage = discountPrice;
      } else {
        discountAmount = discountPrice;
        finalAmount = productPrice - discountAmount;
      }

      const difference = comparedPrice - finalAmount;
      savedPercentage = (difference / comparedPrice) * 100;
      savedPrice = comparedPrice - finalAmount;

      return {
        discountAmount: discountAmount.toFixed(2),
        savedPercentage: savedPercentage.toFixed(2),
        finalAmount: finalAmount.toFixed(2),
        savedPrice: savedPrice.toFixed(2),
      };
    },

    calculateDiscount(
      sellingGroups,
      sellingPlanId,
      discountPercentage,
      productPrice,
      comparedPrice,
      quantity,
      discountType,
      discountPrice
    ) {
      const effectiveDiscountPercentage = this.getSellingPlanDiscount(
        sellingGroups,
        sellingPlanId,
        discountPercentage
      );

      const dataWithSellingPlan = {
        type: "savesub",
        originalProductPrice: productPrice,
        originalComparedPrice: comparedPrice,
        quantity: quantity,
        ...this.calculateSubscriptionDiscount(
          productPrice,
          comparedPrice,
          quantity,
          discountType,
          discountPrice,
          effectiveDiscountPercentage
        ),
      };

      const dataWithoutSellingPlan = {
        type: "onetime",
        originalProductPrice: productPrice,
        originalComparedPrice: comparedPrice,
        quantity: quantity,
        ...this.calculateOneTimeDiscount(
          productPrice,
          comparedPrice,
          discountType,
          discountPrice
        ),
      };

      return sellingPlanId ? dataWithSellingPlan : dataWithoutSellingPlan;
    },

    //Js calculations

    // Update DOM elements for the calculated prices
    updateDOMPrices(priceResult, displayType) {
      document.querySelectorAll(this.selectors.addToCart).forEach((el) => {
        el.textContent = `$${(
          priceResult.finalAmount * priceResult.quantity
        ).toFixed(2)}`;
      });
      document.querySelectorAll(this.selectors.comparedPrice).forEach((el) => {
        el.textContent = `$${(
          this.comparedPrice * priceResult.quantity
        ).toFixed(2)}`;
      });
    },

    updateCommonChanges(priceResult) {
      const quantityInput = document.querySelector(".quantity__input");
      if (quantityInput) {
        quantityInput.value = priceResult.quantity;
        totalQty = quantityInput.value;
      }
      this.showFrequency(priceResult.type, priceResult.savedPercentage);
      this.showQuantitySelected(totalQty);
    },

    // Update DOM elements for the calculated prices of all boxes
    updateQuantityBoxPrices(priceResult) {
      const selectedQuantites = document.querySelectorAll(
        `${this.selectors.quantitySelector}`
      );
      if (!selectedQuantites.length > 0) return null;

      selectedQuantites.forEach((el) => {
        const value = parseInt(el.value);
        const showPriceIn = el.dataset.showPriceIn;
        const discountType = el.dataset.subscriptionDiscountType;
        const discountPrice = parseFloat(el.dataset.discountPrice);
        const sellingPlanId = document.querySelector(
          'input[name="selling_plan"]'
        )?.value; // Example selling plan ID or empty for one-time purchase

        const priceResult = this.calculateDiscount(
          this.sellingGroupsPlan,
          sellingPlanId,
          this.sellPercentage,
          this.productPrice,
          this.comparedPrice,
          value,
          discountType,
          discountPrice
        );

        // Get the parent label element
        const label = el.parentNode;
        const pricingEach = label?.querySelector(".pricingEach");
        const saveText = label?.querySelector(".saveText");
        const finalAmount = priceResult?.finalAmount ?? 0;
        const savedPrice = priceResult?.savedPrice ?? 0;
        const savedPercentage = priceResult?.savedPercentage ?? 0;
        const discountAmount = priceResult?.discountAmount ?? 0;
        if (pricingEach) {
          pricingEach.textContent = `$${parseFloat(finalAmount).toFixed(
            2
          )} each`;
        }
        if (saveText) {
          if (showPriceIn == "percentage") {
            saveText.textContent = `SAVE ${parseFloat(savedPercentage).toFixed(
              0
            )}%`;
          } else {
            saveText.textContent = `SAVE $${parseFloat(discountAmount).toFixed(
              0
            )}`;
          }
        }
      });
    },

    // Update DOM elements for the calculated prices of all subscription box
    updateSubscriptionBoxPrices(quantity) {
      const subscritionBoxes = document.querySelectorAll(
        `${this.selectors.subscriptionSelector}`
      );
      if (!subscritionBoxes.length > 0) return null;

      subscritionBoxes.forEach((el) => {
        const type = el.value;
        let sellingPlanId = "";
        if (type == "onetime") {
          sellingPlanId = "";
        } else {
          const nameValue = el
            .getAttribute("name")
            ?.replace(/selling_plan_/, "");
          sellingPlanId = parseInt(nameValue);
        }

        const priceResult = this.calculateDiscount(
          this.sellingGroupsPlan,
          sellingPlanId,
          this.sellPercentage,
          this.productPrice,
          this.comparedPrice,
          quantity.value,
          quantity.discountType,
          quantity.discountPrice
        );

        // Get the parent label element
        const label = el.parentNode;
        const pricing = label?.querySelector(".addednewPrice");
        const discountedPricing = label?.querySelector(
          ".discountedPrice strike"
        );
        const saveText = label?.querySelector(".rc-option__discount");
        const finalAmount = priceResult?.finalAmount ?? 0;
        const savedPrice = priceResult?.savedPrice ?? 0;
        const savedPercentage = priceResult?.savedPercentage ?? 0;
        const qty = priceResult?.quantity ?? 1;
        const discountAmount = priceResult?.discountAmount ?? 0;
        
        const regPriceOneTime = document.querySelector('.regularPrice');
                
        if (pricing) {
          pricing.textContent = `$${(
            parseFloat(finalAmount) * parseFloat(qty)
          ).toFixed(2)}`;
        }
        setTimeout(() => {
          const regpriceupdated = parseFloat(regPriceOneTime.textContent.replace(/[^\d.]/g, ''));

        const discountAmountgot = regpriceupdated * 0.2;
        if (saveText) {
          if (quantity.showPriceIn == "percentage") {
            saveText.textContent = `SAVE ${parseFloat(savedPercentage).toFixed(
              0
            )}%`;
          } else {
            saveText.textContent = `SAVE $${(
              parseFloat(discountAmountgot)
            ).toFixed(0)}`;
          }
        }
            
                if (discountedPricing) {
                    discountedPricing.textContent = `${regPriceOneTime.textContent}`;
                }
            }, 10); 
          });
    },
  };

  // Initialize the managers
  const rechargeManager = new ReChargeWidgetManager();

  rechargeManager
    .initialize()
    .then(() => {
      return PriceManager.init(); // Chain PriceManager initialization
    })
    .then(() => {
      // Hide skeleton and show content once everything is loaded
      console.log("Hello done");
    })
    .catch((error) => {
      console.error("Failed to initialize managers:", error);
      skeleton.innerHTML =
        "<p>Failed to load content. Please try again later.</p>";
    });
});
